"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHeader = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const AlertWatchHandler_1 = __importDefault(require("@opsbase/web-alertwatcher/AlertWatchHandler"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const HelpIcon_1 = __importDefault(require("@opsbase/web-icons/icons/HelpIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const useNav_1 = __importStar(require("@opsbase/web-nav/useNav"));
const TaskWatchHandler_1 = __importDefault(require("@opsbase/web-taskwatcher/TaskWatchHandler"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const AppTopNav_1 = __importDefault(require("../nav/AppTopNav"));
const AppTitle_1 = __importDefault(require("./AppTitle"));
const AppUserMenu_1 = __importDefault(require("./AppUserMenu"));
const makeMyClasses = () => ({
    root: {
        width: '100%',
        backgroundColor: lib_palette_1.default.White.main,
        paddingTop: 20,
        paddingBottom: 22,
        borderBottom: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
        ['@media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm)']: {
            padding: '0 16px',
        },
    },
});
exports.AppHeader = react_1.default.memo((props) => {
    const { children, version } = props;
    const { navs, hasSupport, hasAlerts } = (0, useAppState_1.default)();
    const { hasFeature } = (0, useSelfActions_1.default)();
    const { getCurrent } = (0, useNav_1.default)();
    const currentPage = getCurrent(navs);
    const self = (0, useSelf_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const siblings = (0, react_1.useMemo)(() => {
        if (!currentPage)
            return [];
        const parent = (0, useNav_1.flattenNavs)(navs).find(n => { var _a; return ((_a = n === null || n === void 0 ? void 0 : n.subnavs) === null || _a === void 0 ? void 0 : _a.indexOf(currentPage)) >= 0; });
        return parent === null || parent === void 0 ? void 0 : parent.subnavs.filter(n => hasFeature(n.flag));
    }, [navs, currentPage, hasFeature]);
    return (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.root }, gutter: true, padding: true, shrink: true, centered: true },
        react_1.default.createElement(Pane_1.default, { grow: true, scrollX: true },
            !(siblings === null || siblings === void 0 ? void 0 : siblings.length) && react_1.default.createElement(AppTitle_1.default, { currentPage: currentPage }),
            !!(siblings === null || siblings === void 0 ? void 0 : siblings.length) && react_1.default.createElement(AppTopNav_1.default, { navs: siblings, selected: currentPage })),
        !!children && react_1.default.createElement(Pane_1.default, { grow: true }, children),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(Text_1.default, null, self.organisationTitle)),
        react_1.default.createElement(Pane_1.default, { visible: true },
            react_1.default.createElement(TaskWatchHandler_1.default, null)),
        hasAlerts && (react_1.default.createElement(Pane_1.default, { visible: true },
            react_1.default.createElement(AlertWatchHandler_1.default, null))),
        hasSupport && (react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(IconButton_1.default, { size: 32, round: true, icon: react_1.default.createElement(HelpIcon_1.default, { color: lib_palette_1.default.GreyBlue, size: 32 }), link: lib_env_1.default.apis.support, target: "_blank" }))),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(AppUserMenu_1.default, { version: version }))));
});
exports.default = exports.AppHeader;
